<!-- <p *ngIf="!showInput && value.value && value.value !== ''" nz-tooltip [nzTooltipTitle]="value.value"
  (click)="toggleShowInput()" [ngStyle]="{'overflow': overflow }">{{value.value}}</p> -->
<input [disabled]="disabled" [placeholder]="placeholder" *ngIf="type === 'text'" #input nz-input
  [formControl]="value" />
<nz-input-number [nzDisabled]="disabled" [nzPlaceHolder]="placeholder" *ngIf="type === 'number'" nzMin="0"
  [formControl]="value" class="input" #input>
</nz-input-number>